export default "__VITE_ASSET__CZXHhbej__"